import Dropdown from "./components/Dropdown";

export default () => {
	const menuWrapperPrimary: HTMLElement | null = document.querySelector(
		".header .nav--primary>.nav--primary__list"
	);

	const menuWrapperTop: HTMLElement | null = document.querySelector(
		".header .nav--top>.nav--top__list"
	);

	if (!menuWrapperPrimary || !menuWrapperTop) return;

	const menusWrapper: HTMLElement[] = [menuWrapperPrimary, menuWrapperTop];


	menusWrapper.forEach(menuWrapper => {
		const menuItems: HTMLElement[] = Array.from(
			menuWrapper.querySelectorAll(".dropdown")
		);

		menuItems.map((menuItem: HTMLElement) => Dropdown(menuItem, menuWrapper));

		if (window.innerWidth < 900) {
			const nav: HTMLDivElement | null = document.querySelector(".nav");
			const burger: HTMLElement | null = document.querySelector(".header__burger");

			if (!nav || !burger) {
				return
			}

			const navPrimary: HTMLDivElement | null = nav.querySelector(".nav__wrapper");
			const navTop: HTMLElement | null = nav.querySelector(".nav--top");
			const returnButton: HTMLButtonElement | null = nav.querySelector(".nav__return");
			const submenuItems: NodeListOf<HTMLLIElement> = nav.querySelectorAll(".dropdown");
			const submenu: NodeListOf<HTMLUListElement> | null = nav.querySelectorAll(".submenu");

			submenuItems?.forEach((item, index) => {
				const title: HTMLSpanElement | null = item.querySelector(".dropdown__label");

				if (!title || !submenu || !returnButton || !navPrimary || !navTop) {
					return
				}

				title.onclick = () => {
					nav.classList.add('active')
					navPrimary.classList.add('active');
					navTop.classList.add('active');
					submenu[index].classList.add('active');
				};

				returnButton.onclick = () => {
					nav.classList.remove('active')
					navPrimary.classList.remove('active');
					navTop.classList.remove('active');
					submenu.forEach(element => {
						element.classList.remove('active');
					});
				};

				burger.onclick = () => {
					nav.classList.toggle('open');
					burger.classList.toggle('open');
					nav.classList.remove('active')
					navPrimary.classList.remove('active');
					navTop.classList.remove('active');
					submenu.forEach(element => {
						element.classList.remove('active');
					});
				}
			});
		}
	})
};
